//Require static assets

//Module Imports
import baseComponent from '../baseComponent';

const validateSettings = [
    {
        setting                 :   "content",
        isRequired              :   true,
        validate                :   "type",//a type or a value
        possibleValues          :   ["string","object"],
        errorMessage            :   ["GDK Credit Card : Content must be defined and set to a DOM selector or Node"]
    }
];

/**
 * CreditCard Class
 */
class CreditCard{
    /**
     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
     * @param {string|Object} content
     * A reference to the div form field containing the credit card input node
     *
     */

    constructor(options) {

        this._internalVars = {

            creditCards : {
                americanExpress : {
                    validDigits : ['34', '37'],
                    cardFormat : 'alternate',
                    cardFormatArray : [4,6,5],
                    accepted : true
                },
                visa : {
                    validDigits : ['4'],
                    cardFormat : 'general',
                    cardFormatArray : [4,4,4,4],
                    accepted : true
                },
                mastercard : {
                    validDigits : ['2221-2720', '51-55'],
                    cardFormat : 'general',
                    cardFormatArray : [4,4,4,4],
                    accepted : true
                },
                discover : {
                    validDigits : ['6011', '64', '65'],
                    cardFormat : 'general',
                    cardFormatArray : [4,4,4,4],
                    accepted : true
                },
                dinersClub : {
                    validDigits : ['300-305', '3095', '36', '38-39'],
                    cardFormat : 'alternate',
                    cardFormatArray : [4,5,4],
                    accepted : false
                },
                jcb : {
                    validDigits : ['3528-3589'],
                    cardFormat : 'general',
                    cardFormatArray : [4,4,4,4],
                    accepted : false
                }
            }
        };

        //options with defaults set
        this._defaults = {};

        // Create options by extending defaults with the passed in arugments
        if (options && typeof options === "object") {
            this._options = baseComponent.extendDefaults(this._defaults, options);
        }

        //if the required options are valid set up the environment
        if( baseComponent.validateSettings(this._options, validateSettings) ){
            this._internalVars.contentType = baseComponent.getContentType(this);
            setLocalVars.call(this);
            setEvents.call(this);
        }
    }

    //Public Methods

    /**
     * getCardType()
     * returns the card type
     * @returns {*|string}
     */
    getCardType() {
        switch (this._internalVars.creditCardType) {
            case 'default':
                this._internalVars.creditCardType = 'invalid CC';
                break;
            case 'jcb':
                this._internalVars.creditCardType = 'invalid: JCB';
                break;
            case 'dinersClub':
                this._internalVars.creditCardType = 'invalid: Diners Club';
                break;
        }
        return this._internalVars.creditCardType;
    }

    /**
     * getCardInputValue()
     * returns the card input value without formatting
     * @returns {*|string}
     */
    getCardInputValue() {
        return this._internalVars.creditCardInputValue;
    }

    /**
     * setCardInputValue(cardNumber)
     * sets the card number
     * @param {string} cardNumber
     * The card number to be populated in the input field
     */
    setCardInputValue(cardNumber) {
        if(cardNumber) {
            this._internalVars.creditCardInput.value = cardNumber;
            this._internalVars.creditCardInput.value = this._internalVars.creditCardInput.value.replace(/\D/g,'');
            change.call(this);
        }
    }

    /**
     * destroy()
     * removes the node from the dom and any events attached
     */
    destroy(){
        removeEvents.call(this);
        this._internalVars.node.parentNode.removeChild(this._internalVars.node);

        //a little garbage collection
        for (var variableKey in this){
            if (this.hasOwnProperty(variableKey)){
                delete this[variableKey];
            }
        }
    }

}

// Private Methods
/**
 * setEvents()
 * Sets all the events needed for the component
 */
function setEvents() {
    this._internalVars.creditCardInput.addEventListener('paste', paste.bind(this));
    this._internalVars.creditCardInput.addEventListener('keypress', validateKeyPress.bind(this));
    this._internalVars.creditCardInput.addEventListener('keyup', checkValue.bind(this));
    this._internalVars.creditCardInput.addEventListener('input', change.bind(this));
    this._internalVars.creditCardInput.addEventListener('blur', validateField.bind(this));
}


/**
 * removeEvents()
 * removes all events from the component
 */
function removeEvents() {
    this._internalVars.creditCardInput.removeEventListener('paste', paste.bind(this));
    this._internalVars.creditCardInput.removeEventListener('keypress', validateKeyPress.bind(this));
    this._internalVars.creditCardInput.removeEventListener('keyup', checkValue.bind(this));
    this._internalVars.creditCardInput.removeEventListener('input', change.bind(this));
    this._internalVars.creditCardInput.removeEventListener('blur', validateField.bind(this));
}

/**
 * paste(event)
 * @param event
 * removes non-numeric characters and formats numeric characters
 */
function paste(event) {
    let currentLength = this._internalVars.creditCardInput.value.length;
    //allow time for value to be recognized
    var delay = setTimeout(pasteComplete.bind(this), 100);
    function pasteComplete() {
        //remove non-numeric characters
        this._internalVars.creditCardInput.value = this._internalVars.creditCardInput.value.replace(/\D/g,'');
        change.call(this);
        //set cursor position
        for(var i = 0; i < this._internalVars.sequenceArray.length; i++) {
            if (this._internalVars.creditCardInput.value.length === this._internalVars.sequenceArray[i] + (i + 1)) {
                currentLength = currentLength + 1;
            }
        }
        this._internalVars.creditCardInput.setSelectionRange(this._internalVars.creditCardInput.value.length - currentLength, this._internalVars.creditCardInput.value.length - currentLength);
    }
}

/**
 * validateKeyPress(event)
 * @param event
 * restrict non-numeric characters
 */
function validateKeyPress(event) {
    let keyCode = event.which || event.keyCode;
    if((keyCode > 0 && keyCode < 8) || (keyCode > 9 && keyCode < 37) || (keyCode > 38 && keyCode < 48) || (keyCode > 57 && keyCode < 96) || (keyCode > 95 && keyCode < 230)) {
        event.preventDefault();
    }
}

/**
 * checkValue(event)
 * @param event
 * set card properties, image, and format
 */
function checkValue(event) {
    let keyCode = event.which || event.keyCode;

    if(keyCode === 8) {
        setCardFormat.call(this, keyCode);
    }
}

/**
 * change()
 * Triggers function when input value changes
 */
function change() {
    setCardProperties.call(this);
    setCardImage.call(this);
    setCardFormat.call(this);
}

/**
 * setCardProperties()
 * set card type/format etc.
 */
function setCardProperties() {
    // Set variable identifying a matching card
    let cardIsSet = false;
    let inputValue = this._internalVars.creditCardInput.value.replace(/ /g, '');

    // loop through credit cards object
    for (var key in this._internalVars.creditCards) {
        if(this._internalVars.creditCards.hasOwnProperty(key)) {
            //loop through the validDigits array inside credit card object
            for(var digits in this._internalVars.creditCards[key].validDigits) {
                //Set properties if entry matches valid digits
                if(this._internalVars.creditCards[key].validDigits[digits].indexOf('-') >= 0) {
                    let hyphenPosition = this._internalVars.creditCards[key].validDigits[digits].indexOf('-');
                    let beginingPoint = this._internalVars.creditCards[key].validDigits[digits].substring(0, hyphenPosition);
                    let endPoint = this._internalVars.creditCards[key].validDigits[digits].substring(hyphenPosition + 1, this._internalVars.creditCards[key].validDigits[digits].length);
                    if(inputValue.substring(0, hyphenPosition) >= beginingPoint && inputValue.substring(0, hyphenPosition) <= endPoint) {
                        this._internalVars.creditCardType = key;
                        this._internalVars.cardFormat = this._internalVars.creditCards[key].cardFormat;
                        this._internalVars.cardFormatArray = this._internalVars.creditCards[key].cardFormatArray;
                        cardIsSet = true;
                    }
                } else {
                    if(inputValue.substring(0,this._internalVars.creditCards[key].validDigits[digits].length) === this._internalVars.creditCards[key].validDigits[digits]) {
                        this._internalVars.creditCardType = key;
                        this._internalVars.cardFormat = this._internalVars.creditCards[key].cardFormat;
                        this._internalVars.cardFormatArray = this._internalVars.creditCards[key].cardFormatArray;
                        cardIsSet = true;
                    }
                }
            }
        }
    }

    //Set default properties if entry does not match valid digits
    if(cardIsSet === false) {
        this._internalVars.creditCardType = 'default';
        this._internalVars.cardFormat = 'general';
        this._internalVars.cardFormatArray = [4,4,4,4];
    }

    //Set sequence array based on card format
    this._internalVars.sequenceArray = [];

    let sequenceNumber = 0;
    Array.prototype.forEach.call(this._internalVars.cardFormatArray, (formatNumber)=> {
        sequenceNumber += formatNumber;
        this._internalVars.sequenceArray.push(sequenceNumber);
        this._internalVars.cardMaxLenth = sequenceNumber + this._internalVars.cardFormatArray.length - 1;
    });
}

/**
 * setCardImage()
 * sets the card type image on the view
 */
function setCardImage() {
    if(this._internalVars.creditCardType !== 'default' && this._internalVars.creditCards[this._internalVars.creditCardType].accepted !== false) {
        this._internalVars.creditCardImageField.setAttribute('class', 'credit-card-image ' + this._internalVars.creditCardType);
    } else {
        this._internalVars.creditCardImageField.setAttribute('class', 'credit-card-image');
    }
}

/**
 * setCardFormat(key)
 * @param key
 * formats the entry based on the card type
 */
function setCardFormat(key) {
    //Set max length based on card type
    this._internalVars.creditCardInput.setAttribute('maxlength', this._internalVars.cardMaxLenth);

    //Set variables for cursor position
    let caretPos = this._internalVars.creditCardInput.selectionStart;
    let cursorPosition = caretPos;

    //remove next available number if backspacing over a space
    if(key === 8) {
        for(var b = 0; b < this._internalVars.sequenceArray.length; b++) {
            if(caretPos === this._internalVars.sequenceArray[b] + b) {
                let first = this._internalVars.creditCardInput.value.slice(0, caretPos-1);
                let second = this._internalVars.creditCardInput.value.slice(caretPos, this._internalVars.creditCardInput.value.length);
                this._internalVars.creditCardInput.value = first + second;
                cursorPosition = caretPos - 1;
            }
        }
    }

    //Set variable containing input value and previous value without spaces
    let inputValue = this._internalVars.creditCardInput.value.replace(/ /g, '');
    this._internalVars.creditCardInputValue = inputValue;
    let prevInputValue = this._internalVars.creditCardInputPreviousValue.replace(/ /g, '');
    let difference = inputValue.length - prevInputValue.length;

    let newValueArray = [];
    for(var v = 0; v < this._internalVars.sequenceArray.length; v++) {
        if(inputValue.length >= this._internalVars.sequenceArray[v]-this._internalVars.cardFormatArray[v]) {
            newValueArray.push(inputValue.substring(this._internalVars.sequenceArray[v]-this._internalVars.cardFormatArray[v],this._internalVars.sequenceArray[v]));
        }
    }

    //check if multiple keys pressed
    if (key !== 8) {
        if(this._internalVars.creditCardInputPreviousValue.length + 1 < this._internalVars.creditCardInput.value.length) {
            for(var i = 0; i < this._internalVars.sequenceArray.length; i++) {
                if(caretPos - difference < this._internalVars.sequenceArray[i] + (i + 1) && caretPos > this._internalVars.sequenceArray[i] + (i + 1)) {
                    cursorPosition = caretPos + 1;
                }
            }
        }
    }

    //combine value arrays with a space
    let newValue = newValueArray.join(' ');
    this._internalVars.creditCardInput.value = newValue;

    //update cursor position and/or add a space if a number is pressed
    if(key !== 8) {
        for(var s = 0; s < this._internalVars.sequenceArray.length; s++) {
            if(caretPos + (difference - 1) > this._internalVars.sequenceArray[s] + (s + 1) && caretPos <= this._internalVars.sequenceArray[s] + (s + 1)) {
                cursorPosition = caretPos + 1;
            }
            if(s + 1 !== this._internalVars.cardFormatArray.length && caretPos === this._internalVars.sequenceArray[s] + s && this._internalVars.creditCardInputPreviousValue.length !== this._internalVars.creditCardInput.value.length) {
                cursorPosition = caretPos + 1;
                if(caretPos === this._internalVars.creditCardInput.value.length) {
                    this._internalVars.creditCardInput.value = this._internalVars.creditCardInput.value + ' ';
                }
            }
        }
    }

    this._internalVars.creditCardInputPreviousValue = this._internalVars.creditCardInput.value;
    this._internalVars.creditCardInput.setSelectionRange(cursorPosition, cursorPosition);
}

/**
 * validateField()
 * shows an error message if the card is not accepted or the field is incomplete
 */
function validateField() {
    let invalidEntryError = 'Please enter a valid credit card number',
        invalidCardError = 'Please use American Express, Visa, Mastercard, or Discover',
        errorMessage,
        invalidEntry = false;

    //console.log(this._internalVars.creditCards[this._internalVars.creditCardType].accepted);
    if(this._internalVars.creditCardInput.value.length !== this._internalVars.cardMaxLenth) {
        invalidEntry = true;
        errorMessage = invalidEntryError;
    } else if (this._internalVars.creditCardType === 'default') {
        invalidEntry = true;
        errorMessage = invalidEntryError;
    } else if (this._internalVars.creditCards[this._internalVars.creditCardType].accepted === false) {
        invalidEntry = true;
        errorMessage = invalidCardError;
    } else {
        invalidEntry = false;
    }

    if(invalidEntry === true) {
        if(this._internalVars.creditCardField.classList.contains('form-field--error')) {
            let errorObj = document.getElementById('form-message-' + this._internalVars.creditCardField.id);
            errorObj.innerHTML = errorMessage;
        } else {
            this._internalVars.creditCardField.classList.add('form-field--error');
            this._internalVars.creditCardInput.setAttribute('aria-invalid', 'true');

            let error = document.createElement('span');
            error.id = 'form-message-' + this._internalVars.creditCardField.id;
            error.className = 'form-message';
            error.innerHTML = errorMessage;

            this._internalVars.creditCardField.appendChild(error);
        }
    } else {
        if(this._internalVars.creditCardField.classList.contains('form-field--error')) {
            this._internalVars.creditCardField.classList.remove('form-field--error');
            this._internalVars.creditCardInput.setAttribute('aria-invalid', 'false');
            let errorObj = document.getElementById('form-message-' + this._internalVars.creditCardField.id);
            errorObj.parentNode.removeChild(errorObj);
        }
    }
}

/**
 * setLocalVars()
 * set all the local vars to passed in options
 */
function setLocalVars() {
    //determine the type of content passed in
    if(this._internalVars.contentType === 'string'){
        this._internalVars.node = document.querySelector(this._options.content);
    }else if(this._internalVars.contentType === 'domNode'){
        this._internalVars.node = this._options.content;
    }

    this._internalVars.creditCardField = this._internalVars.node;
    this._internalVars.creditCardClass = 'credit-card';
    this._internalVars.creditCardInput = this._internalVars.creditCardField.querySelector('.' + this._internalVars.creditCardClass);
    this._internalVars.creditCardImageClass = 'credit-card-image';
    this._internalVars.creditCardImageField = this._internalVars.creditCardField.querySelector('.' + this._internalVars.creditCardImageClass);

    this._internalVars.creditCardInputPreviousValue = this._internalVars.creditCardInput.value;
    this._internalVars.creditCardInputValue = null;
}

export default CreditCard;


// WEBPACK FOOTER //
// ./src/js/geico-design-kit/components/CreditCard.js